import { Entity, Field } from "typegraph";

@Entity({one: "organization", many: "userOrganizations"})
export default class Organization {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public logoURL: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/entities/Organization.ts